<template>
  <div>
    <b-table
      class="mb-0 table-outline"
      responsive="sm"
      stacked="md"
      hover
      :items="tableItems"
      :fields="tableFields"
      :per-page="100"
      head-variant="light"
      style="width:100%; background-color:#FFF; margin-bottom: 0;">
      <div slot="info" slot-scope="item">
        {{item.value.name}}
      </div>
      <div slot="status" slot-scope="item">
        <strong>
          <template v-if="item.value === 'ONLINE'"><span style="color:green;">{{item.value}}</span></template>
          <template v-else-if="item.value === 'PENDING'"><span style="color:orange;">{{item.value}}</span></template>
          <template v-else><span style="color:red;">{{item.value}}</span></template>
        </strong>
      </div>
      <div slot="tracker" slot-scope="item">
        <template v-if="item.value.total">
          <b-progress class="progress-sm" :max="item.value.total">
            <b-progress-bar :class="item.item.trackerColors.track.class" :value="item.value.track"
              v-b-popover.hover="`Track: ${item.value.track}/${item.value.total}`"></b-progress-bar>
            <b-progress-bar :class="item.item.trackerColors.stow.class" :value="item.value.stow"
              v-b-popover.hover="`Stow: ${item.value.stow}/${item.value.total}`"></b-progress-bar>
            <b-progress-bar :class="item.item.trackerColors.idle.class" :value="item.value.idle"
              v-b-popover.hover="`Idle: ${item.value.idle}/${item.value.total}`"></b-progress-bar>
            <b-progress-bar :class="item.item.trackerColors.sleep.class" :value="item.value.sleep"
              v-b-popover.hover="`Sleep: ${item.value.sleep}/${item.value.total}`"></b-progress-bar>
            <b-progress-bar :class="item.item.trackerColors.error.class" :value="item.value.error"
              v-b-popover.hover="`Error: ${item.value.error}/${item.value.total}`"></b-progress-bar>
            <b-progress-bar :class="item.item.trackerColors.other.class" :value="item.value.other"
              v-b-popover.hover="`Other: ${item.value.other}/${item.value.total}`"></b-progress-bar>
            <b-progress-bar :class="item.item.trackerColors.unknown.class" :value="item.value.unknown"
              v-b-popover.hover="`Unknown: ${item.value.unknown}/${item.value.total}`"></b-progress-bar>
          </b-progress>
        </template>
      </div>
      <div slot="armature" slot-scope="item">
        <template v-if="item.value.total">
          <b-progress class="progress-sm" :max="item.value.total">
            <b-progress-bar :class="item.item.armColors.healthy.class" :value="item.value.healthy"
              v-b-popover.hover="`Healthy: ${item.value.healthy}/${item.value.total}`"></b-progress-bar>
            <b-progress-bar :class="item.item.armColors.azimuthError.class" :value="item.value.azimuthError"
              v-b-popover.hover="`Azimuth Error: ${item.value.azimuthError}/${item.value.total}`"></b-progress-bar>
            <b-progress-bar :class="item.item.armColors.elevationError.class" :value="item.value.elevationError"
              v-b-popover.hover="`Elevation Error: ${item.value.elevationError}/${item.value.total}`"></b-progress-bar>
            <b-progress-bar :class="item.item.armColors.otherError.class" :value="item.value.otherError"
              v-b-popover.hover="`Other Error: ${item.value.otherError}/${item.value.total}`"></b-progress-bar>
            <b-progress-bar :class="item.item.armColors.unknownError.class" :value="item.value.unknownError"
              v-b-popover.hover="`Unknown Error: ${item.value.unknownError}/${item.value.total}`"></b-progress-bar>
          </b-progress>
        </template>
      </div>
      <div slot="details" slot-scope="item">
        <b-button size="sm" :v-b-modal=armModalId @click="displayArmModal(item.item.info.id)">Preview Data</b-button>
      </div>
      <div slot="weather" slot-scope="item">
        <b-button size="sm" :v-b-modal=weatherModalId @click="displayWeatherModal(item.item.info.id)">Preview Weather</b-button>
      </div>
    </b-table>
    <b-modal
      :ref="armModalId"
      body-class="armErrModalBody"
      :hide-header="true"
      :ok-only="true"
      ok-title="Close"
      ok-variant="danger"
      size="lg">
      <armature-errors :gcu=gcu></armature-errors>
    </b-modal>
    <b-modal
      :ref="weatherModalId"
      body-class="weatherModalBody"
      :hide-header="true"
      :ok-only="true"
      ok-title="Close"
      ok-variant="danger"
      size="lg">
      <weather-summary :gcu=gcu></weather-summary>
    </b-modal>
  </div>
</template>

<script>
import ArmatureErrors from './ArmatureErrors';
import WeatherSummary from './WeatherSummary';

export default {
  name: 'GcuSummary',
  data() {
    return {
      tableFields: {
        info: {
          label: 'GCU'
        },
        status: {
          label: 'Status'
        },
        tracker: {
          label: 'Tracker Status'
        },
        armature: {
          label: 'Armature Status'
        },
        details: {
          label: ''
        },
        weather: {
          label: 'Weather'
        }
      },
      gcu: null
    };
  },
  computed: {
    armModalId() {
      return `${this.site.split(' ').join('')}ArmModal`;
    },
    weatherModalId() {
      return `${this.site.split(' ').join('')}WeatherModal`;
    }
  },
  props: {
    tableItems: {
      type: Array
    },
    site: {
      type: String
    }
  },
  methods: {
    displayArmModal(gcu) {
      this.gcu = gcu;
      this.$refs[this.armModalId].show();
    },
    displayWeatherModal(gcu) {
      this.gcu = gcu;
      this.$refs[this.weatherModalId].show();
    },
    toggleDetails(index, type) {
      this.tableItems.forEach((item, i) => {
        if (i === index) {
          item.show[type] = !item.show[type];
          item._showDetails = !(!item.show.armature && !item.show.weather);
        } else {
          item._showDetails = false;
          item.show.armature = false;
          item.show.weather = false;
        }
      });
    }
  },
  components: {
    ArmatureErrors,
    WeatherSummary
  }
};
</script>

<style>
@media (min-width: 992px) {
  .modal-lg {
    max-width: 75%;
  }
}

.armErrModalBody {
  padding: 0;
}

.weatherModalBody {
  padding: 0;
}

</style>
